// Components/ui
import { Box } from '@mui/material';
import { SubsectionHeaderWithButton } from '../../layout';
import { Body } from './components';
// Types
import { NewAddress } from '../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  RCSs: Array<NewAddress | IContactAddress>;
  handleAdd: () => void;
};
const RCSs = ({ RCSs, handleAdd }: Props) => {
  return (
    <Box sx={{ width: '100%' }}>
      <SubsectionHeaderWithButton handleAdd={handleAdd} title={'RCS'} />
      <Body RCSs={RCSs} />
    </Box>
  );
};

export default RCSs;
